import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { environment } from '../../environments/environment';

import { AuthService } from '../service/auth.service';
import { HomeService } from '../service/home.service';
import { UserService } from '../service/user.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css'],
})
export class UserManagementComponent {
  constructor(
    private vRef: ViewContainerRef,
    private homeService: HomeService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private toastr: ToastsManager
  ) {
    //
    // Need to initialize this to an empty string because otherwise it is undefined until someone types something into the box.
    //
    this.newUserEmail = '';

    //
    // Wireup the toast manager.
    //
    this.toastr.setRootViewContainerRef(vRef);

    this.getAllUsers();
  }

  @Input() print: boolean;

  users: any[] = new Array();

  selectedRow: number;

  newUserEmail: '';

  getAllUsers() {
    this.homeService.getAllUsers().subscribe((response) => {
      this.users = response.data;
    });
  }

  setSelectedRow(index) {
    this.selectedRow = index;
    const newUserId = this.users[index].ralUserId;

    this.authService.impersonateUser(newUserId);

    //
    // Now head back over to /home to prove that we're someone else now
    //
    this.router.navigate(['/home']);
  }

  createUser() {
    const email = this.newUserEmail;
    this.userService.createUser(email).subscribe(
      (newUser) => {
        this.authService.impersonateUser(newUser.userId);

        //
        // Now head back over to /home to prove that we're someone else now
        //
        this.router.navigate(['/home']);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          this.toastr.error(
            `An error occurred while creating the user. Please try again.<br /><br />Error message:<br />${err.error.message}`,
            null,
            { enableHTML: true }
          );
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          //
          // err.error is the JSON that was returned from the API.
          this.toastr.error(err.error.message, 'Error');
        }
      }
    );
  }

  isEmailEmpty(): boolean {
    return (
      this.newUserEmail === undefined ||
      this.newUserEmail === null ||
      this.newUserEmail.length === 0
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/user-management/user-management.component.ts